import BackGroundColor from "../CommanComponents/BackGroundColor";
import { X } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import StatisticQuestion from "../teacher/StatisticQuestion";
import StatisticValue from "../teacher/StatisticValue";
import api from "../utils/api";

function StudentDetailModel({
  visable,
  Close,
  chapter,
  unit,
  studentForId,
  selectChapter,
}) {
  const [chapterDetail, setChapterDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [vocabularyDetail, setVocabularyDetail] = useState({
    Beginner: "",
    Intermediate: [],
    Adwanced: [],
  });
  const [readingDetail, setReadingDetail] = useState({
    Verbs: [],
    Questions: [],
  });
  const [grammarDetail, setGrammarDetail] = useState({
    Examples: [],
    Exercises: [],
  });
  const [speakingDetail, setSpeakingDetail] = useState({
    Beginner: [],
    Intermediate: [],
    Adwanced: [],
  });
  const [isNight, setIsNight] = useState(false);
  useEffect(() => {
    if (!visable || !chapter || !unit) return;

    const getChapterDetail = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get("get_userstatistics", {
          params: {
            userId: studentForId,
            unit: selectChapter,
            chapter: chapter,
          },
        });
        const detail = response.data;
        const detailQuestion = response.data.userstatisticsList.taskStatistics;

        if (chapter.includes("vocabulary")) {
          // Doğru şekilde state güncellemesi yapın
          setVocabularyDetail({
            Beginner: detailQuestion.countStage,
            Intermediate: detail.statisticsVocabularyArray,
            Adwanced: detailQuestion.userAnswers,
          });
        } else if (chapter.includes("grammar")) {
          setGrammarDetail({
            Examples: detail.statisticsGrammarExampleArray,
            Exercises: detail.statisticsGrammarExercisesArray,
          });
        } else if (chapter.includes("reading")) {
          setReadingDetail({
            Verbs: detail.statisticsReadingArray,
            Questions: detailQuestion.userAnswers,
          });
        } else if (chapter.includes("speaking")) {
          setSpeakingDetail({
            Beginner: detail.statisticsBeginnerSpeakingArray,
            Intermediate: detail.statisticsIntermediateSpeakingArray,
            Adwanced: detail.statisticsAdvancedSpeakingArray,
          });
        } else {
          setChapterDetail(setChapterDetail(null));
        }
      } catch (error) {
        console.error("Bir hata oluştu", error);
        setError(error.message || "Veri yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    getChapterDetail();
  }, [visable, chapter, unit, studentForId, selectChapter]);
  const handleclose = () => {
    setVocabularyDetail({
      Beginner: "",
      Intermediate: [],
      Adwanced: [],
    });
    setGrammarDetail({
      Examples: [],
      Exercises: [],
    });
    setReadingDetail({
      Verbs: [],
      Questions: [],
    });
    setSpeakingDetail({
      Beginner: [],
      Intermediate: [],
      Adwanced: [],
    });
    Close();
  };
  if (!visable) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <BackGroundColor isNight={isNight} setIsNight={setIsNight} />
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md max-h-[80vh] flex flex-col z-50">
        {/* Header */}
        <div
          className="bg-yellow-500 flex items-center justify-between 
        p-6 border-b rounded-t-3xl border-gray-100"
        >
          <h3 className="text-lg font-semibold text-white">
            {unit} {chapter}
          </h3>
          <button
            onClick={handleclose}
            className="p-2 bg-white text-red-500 hover:bg-red-500 hover:text-white rounded-full transition-colors "
          >
            <X className="w-6 h-6 " />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-grow">
          <div>
            {chapter.includes("vocabulary") && (
              <div>
                <div>tekrar sayısı:{vocabularyDetail.Beginner}</div>
                <StatisticValue
                  statisticvalues={vocabularyDetail.Intermediate}
                />
                <StatisticQuestion
                  statisticQuestions={vocabularyDetail.Adwanced}
                />
              </div>
            )}
            {chapter.includes("grammar") && (
              <div>
                <StatisticValue statisticvalues={grammarDetail.Examples} />
                <StatisticValue statisticvalues={grammarDetail.Exercises} />
              </div>
            )}
            {chapter.includes("speaking") && (
              <div>
                <StatisticValue statisticvalues={speakingDetail.Beginner} />
                <StatisticValue statisticvalues={speakingDetail.Intermediate} />
                <StatisticValue statisticvalues={speakingDetail.Adwanced} />
              </div>
            )}
            {chapter.includes("reading") && (
              <div>
                <StatisticValue statisticvalues={readingDetail.Verbs} />
                <StatisticQuestion
                  statisticQuestions={readingDetail.Questions}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentDetailModel;
